export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9562.d0080341.jpg";